import React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@utils/lib/utils";

export const CircleProgress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    trackColor?: string;
    trailColor?: string;
    bgColor?: string;
    isValueShown?: boolean;
    customValue?: string | JSX.Element;
  }
>(
  (
    {
      className,
      value,
      trackColor,
      trailColor,
      bgColor,
      isValueShown,
      customValue,
      ...props
    },
    ref
  ) => (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        `relative flex h-20 w-20 items-center justify-center overflow-hidden rounded-full bg-primary/20`,
        className
      )}
      {...props}
      style={{
        background: `radial-gradient(closest-side, ${
          bgColor || "white"
        } 79%, transparent 80% 100%), conic-gradient(${trackColor || "green"} ${
          value || 0
        }%, ${trailColor || "pink"} 0)`,
      }}
    >
      <div className="">
        {customValue || `${isValueShown ? value || 0 + "%" : ""}`}
      </div>
    </ProgressPrimitive.Root>
  )
);
